import React from 'react'
import './index.scss'
const InformationSharing = (props) => {
  return (
    <div className="informationSharing-container">
        <h2>个人信息共享说明</h2>
        <p>为了核实您的实名信息是否真实准确，我们和第三方API合作，并将您提供的实名信息共享给第三方，以进行核验。</p>
        <h3>一、信息处理活动说明</h3>
        <h4>1、身份证信息</h4>
        <p>您输入您的姓名和身份证号上传的身份证照片，我们将上述信息传输给第三方API，第三方API将帮助我们校验其真实性和一致性。</p>
        <h4>2、驾驶证信息</h4>
        <p>您输入的驾驶证号上传的驾驶证照片，我们将上述信息传输给第三方API，第三方API将帮助我们校验其真实性和一致性。</p>
        <h3>二、第三方API主体的信息</h3>
        <div className="table">
            <div className="oneline">
                <div className="oneline-item">
                    角色
                </div>
                <div className="oneline-item">
                    主体名称
                </div>
                <div className="oneline-item">
                    联系方式
                </div>
                <div className="oneline-item">
                    更多个人信息保护相关信息
                </div>
            </div>
            <div className="oneline">
                <div className="oneline-item">
                    第三方API
                </div>
                <div className="oneline-item">
                    苏州众数世纪网络科技有限公司
                </div>
                <div className="oneline-item">
                    邮箱Leete@mulitdata.cn
                </div>
                <div className="oneline-item">
                    /
                </div>
            </div>
            <div className="oneline">
                <div className="oneline-item">
                    第三方API
                </div>
                <div className="oneline-item">
                    腾讯云计算(北京）有限责任公司
                </div>
                <div className="oneline-item">
                    邮箱wingswang@tencent.com
                </div>
                <div className="oneline-item">
                    http://cloud.tencent.com/document/product/1007/60044
                </div>
            </div>
        </div>
    </div>
  )
}
export default InformationSharing
